import { useFormikContext } from "formik";
import React from "react";
import { labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import TextFieldStyles from "../TextField/TextField.module.css";


export default function TextArea({ field_label, parent, isRequired, charactersRange }) {
  const { getFieldProps } = useFormikContext();
  const name = parent ? `${parent}.${field_label}` : field_label;
  const minCharacter = charactersRange.min || '';
  const maxCharacter = charactersRange.max || '';
  return (
    <div className={TextFieldStyles.inputContainer}>
      <div className="label-container" style={{display: 'flex', justifyContent: 'space-between'}}>
        <label htmlFor="textarea" className={TextFieldStyles.label}>{labelName(field_label)}{isRequired==="true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}</label>
          {/* {charactersRange && (
            <div style={{display: 'flex'}}>
              <label className={TextFieldStyles.label}>Min:<span>{minCharacter}</span></label>
              <label className={TextFieldStyles.label}>Max:<span>{maxCharacter}</span></label>
            </div>
          )}         */}
      </div>
      <textarea
        id={field_label}
        className={TextFieldStyles.input}
        {...getFieldProps(name)}
        rows="4"
        cols="50"
        minLength={minCharacter}
        maxLength={maxCharacter}
      ></textarea>
      <ErrorMessage name={name} />
    </div>
  );
}
